export const defaultFilterValue = {
  skip: 0,
  page: 0,
  take: 25,
  sortModel: [],
  filterColumn: [],
  search: "",
  showNonZero: false,
  customFilter: {},
};

export const createCommonFilter = () => ({
  ...defaultFilterValue,
});

export const initialCommonFilterState = {
  advisorList: createCommonFilter(),
  companyList: createCommonFilter(),
  accessList: createCommonFilter(),
  uniqueList: createCommonFilter(),
  historicalList: createCommonFilter(),
  clientList: createCommonFilter(),
  adminList: createCommonFilter(),
};
